<template>
    <div id="nav-header">
      <div class="header-content">
        <router-link tag="div" to="/" class="logo"></router-link>
        <div class="languange-container">
          <language-selector />
        </div>
        <div class="nav-list">
          <ul>
            <router-link tag="li" to="/story">{{$t('menu.journey')}}</router-link>
            <router-link tag="li" to="/kit">{{$t('menu.kit')}}</router-link>
          </ul>
        </div>
      </div>
    </div>
</template>

<script>
import LanguageSelector from "./LanguageSelector";

export default {
    name: "nav-header",
    components: {LanguageSelector}

}
</script>

<style lang="stylus" scoped>
#nav-header
  width: 100%;
  background: #FFFFFF;
  height: 60px;
  display: flex;
  flex-direction row
  box-shadow: 0 4px 9px 1px rgba(216,205,205,0.66);
  .header-content
    display: flex;
    margin 0 10%
    width 100%
    align-items center
    .logo
      display: flex
      background url('~@/../static/images/logo-grey.svg') no-repeat center left
      width 80px
      height 25px
      cursor pointer
    .languange-container
      display: flex;
      margin-left 30px
      width 230px
    .nav-list
      display: flex;
      margin-left: auto;
      text-transform: uppercase;
      letter-spacing:1px;
      ul
        display: flex;
        list-style-type: none;
        li
          margin: 4px 20px;
          color: #707070;
          font-size: 16px;
          cursor: pointer;
          &:hover
            text-decoration: underline;
          &.router-link-exact-active
            font-weight: bold;

</style>



// WEBPACK FOOTER //
// src/components/NavHeader.vue